import { ROUTES } from 'constants/routes';

export const HEADER_NAVIGATION = [
  {
    name: 'Home',
    link: ROUTES.create_authorized,
  },
  {
    name: 'Search PDF',
    link: ROUTES.search_pdf,
  },
  {
    name: 'PDF History',
    link: ROUTES.pdf_history,
  },
  {
    name: 'About us',
    link: ROUTES.about,
  },
];
